import React, { CSSProperties } from "react";
import { LayoutEnum } from "./LayoutEnum";
import { PictureData } from "../../../types/PictureData";
import constants from "../../../utils/constants";
import { IDynamicBlockComponent } from "../../dynamicPageBuilder/IDynamicBlockComponent";

export type Item = {
  header: string;
  content: string;
  background_color: string;
  background_picture?: PictureData;
};

export type TilesInColumnsProps = {
  className?: string;
  background: string;
  data: Array<Item>;
  layout: LayoutEnum;
  description?: string;
};

const TilesInColumns: React.FunctionComponent<IDynamicBlockComponent> = ({
  blockData,
}): React.ReactElement => {
  const {
    data: items,
    layout,
    className,
    description,
    background,
  } = blockData as TilesInColumnsProps;

  const getCardBackground = (
    backgroundColor: string,
    backgroundPicture?: PictureData
  ): CSSProperties => {
    const backgroundImage =
      backgroundPicture &&
      `url(${process.env.NEXT_PUBLIC_IMG_URL + backgroundPicture.publicUrl})`;

    return {
      backgroundColor,
      backgroundImage,
      backgroundSize: "cover",
    };
  };

  const getLayoutClass = (): string => {
    switch (layout) {
      case LayoutEnum.TWO_COLUMNS:
        return "twoColumnsLayout";
      case LayoutEnum.THREE_COLUMNS:
        return "threeColumnsLayout";
      default:
        return "twoColumnsLayout";
    }
  };

  return (
    <div
      className={`${className ? className : ""} ${
        background === constants.GREY_BACKGROUND ? "mainBackgroundGrey" : ""
      }`}
    >
      <div className="desktop-container tilesInColumns">
        {description && (
          <div
            className="top_description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <div className={`layout__tile ${getLayoutClass()}`}>
          {items.map((item, index) => (
            <div
              key={`card_${index}`}
              className="tile__item"
              style={getCardBackground(
                item.background_color,
                item.background_picture
              )}
            >
              <div
                className="tile__header"
                dangerouslySetInnerHTML={{ __html: item.header }}
              />
              <div
                className="tile__text"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TilesInColumns;
